import { useMutation } from "@tanstack/react-query";
import { disconnectMcp } from "../../api/bMcpApi";

export const useDisconnectMcp = () => {
  return useMutation({
    mutationKey: ["disconnect-mcp"],
    mutationFn: (data) => disconnectMcp(data),
    onError: (error) => {
      console.error("MCP disconnect error:", error.response || error);
    },
  });
};
